import * as Api from '../../../weborder/Api';

const getAppConfig = (state: WebOrder.State): Api.AppConfig =>
  state.flipdish.AppConfig &&
  state.flipdish.AppConfig.status === 'success' &&
  state.flipdish.AppConfig.data;

export const whitelabelSelectors = {
  getAppConfig,
};
